module.exports = __webpack_public_path__ + "static/AMOEBA-1017ca20b3723ce4894fe47735e079d1.png";